import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=2b032cc7&scoped=true&"
var script = {}
import style0 from "./Register.vue?vue&type=style&index=0&id=2b032cc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b032cc7",
  null
  
)

export default component.exports